/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * 都道府県（東海エリア）
 */
export enum UserPrefecture {
  AICHI = "愛知県",
  GIFU = "岐阜県",
  MIE = "三重県",
  SHIZUOKA = "静岡県"
}
